import React from 'react';
import { Icon } from '@iwoca/orion';
import { Icons } from '@iwoca/orion/lib/components/icon/Icon';
import clsx from 'clsx';
import { Link, LinkProps } from 'react-router-dom';
import styles from './ButtonLink.module.css';

type TProps = {
  icon?: (typeof Icons)[number];
  className?: string;
  linkClassName?: string;
  iconPosition?: 'left' | 'right';
  linkProps?: LinkProps;
  href?: string;
} & React.ComponentProps<'button'>;

export const ButtonLink = ({
  icon,
  children,
  className,
  iconPosition = 'right',
  linkProps,
  linkClassName,
  href,
  ...props
}: TProps) => {
  const iconComponent = icon ? (
    <Icon className={styles.icon} icon={icon} />
  ) : undefined;

  const component = (
    <button className={clsx(styles.buttonLink, className)} {...props}>
      {iconPosition === 'left' && iconComponent}
      {children}
      {iconPosition === 'right' && iconComponent}
    </button>
  );

  if (linkProps || href) {
    return (
      <Link
        to={href as string}
        className={clsx(styles.linkWrapper, linkClassName)}
        {...linkProps}
      >
        {component}
      </Link>
    );
  }
  return component;
};
